module.exports = __webpack_public_path__ + "static/media/warning-icon.f625b05e.svg";